import { useState } from "react";
import Swal from "sweetalert2";
import getCurrentUser from "../../../../utils/getCurrentUser";

export const useAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  const checkAdmin = () => {
    const currentUser = getCurrentUser();
    if (currentUser && currentUser.isAdmin) {
      setIsAdmin(true);
    } else {
      Swal.fire({
        title: "Unauthorized",
        text: "You are not authorized for this session",
        icon: "error",
        timer: 2000,
        willClose: () => {
          window.location.href = "/";
        },
      });
    }
  };
  return {
    isAdmin,
    checkAdmin,
  };
};
